import { cosemApi } from '@services/providers/cosem';
import { FlashInfo, FlashInfoTable, FlashInfoToCreate, FlashInfoToUpdate } from './flash-info.types';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';
import { ActiveFilter } from '@utils/filters';

const flashInfoApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getFlashInfos: build.mutation<
            ApiPaginationResponse<FlashInfoTable>,
            { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/member/flash-infos`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<FlashInfoTable>) => response
        }),
        getFlashInfo: build.mutation<ApiResponse<FlashInfo>, { id: string }>({
            query: ({ id }) => {
                return {
                    url: `/member/flash-infos/${id}`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<FlashInfo>) => response
        }),
        postFlashInfo: build.mutation<ApiResponse<FlashInfo>, FlashInfoToCreate>({
            query: (flashInfo: FlashInfoToCreate) => {
                return {
                    url: `/member/flash-infos`,
                    method: 'POST',
                    body: flashInfo
                };
            },
            transformResponse: (response: ApiResponse<FlashInfo>) => response
        }),
        putFlashInfo: build.mutation<ApiResponse<FlashInfo>, { id: string; flashInfo: FlashInfoToUpdate }>({
            query: ({ id, flashInfo }) => {
                return {
                    url: `/member/flash-infos/${id}`,
                    method: 'PUT',
                    body: flashInfo
                };
            },
            transformResponse: (response: ApiResponse<FlashInfo>) => response
        }),
        toggleArchiveFlashInfo: build.mutation<ApiResponse<FlashInfo>, { id: string | number; archived: boolean }>({
            query: ({ id, archived }) => {
                return {
                    url: `/member/flash-infos/${id}/archive`,
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<FlashInfo>) => response
        }),
        toggleFlashInfoActive: build.mutation<ApiResponse<void>, { id: string|number }>({
            query: ({ id }) => {
                return { 
                    url: `/member/flash-infos/${id}/toggle`,
                    method: 'PUT'
                };
            },
            transformResponse: (response: ApiResponse<void>) => response
        }),
        getArchivedFlashInfos: build.mutation<
            ApiPaginationResponse<FlashInfoTable>,
            { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/member/flash-infos/archived`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<FlashInfoTable>) => response
        }),
    })
});

export const {
    useGetFlashInfosMutation,
    useGetFlashInfoMutation,
    useGetArchivedFlashInfosMutation,
    usePostFlashInfoMutation,
    usePutFlashInfoMutation,
    useToggleArchiveFlashInfoMutation,
    useToggleFlashInfoActiveMutation
} = flashInfoApi;
